import React, { useEffect, useState } from "react";
import "../TimedWheel/timedwheel.scss";
import { ASSETS } from "../../utils/config";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Typography from "@mui/material/Typography";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";
import StarRateRoundedIcon from "@mui/icons-material/StarRateRounded";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ReplayIcon from "@mui/icons-material/Replay";
import Hotbar from "./hotbar";
import LinkIcon from "./icons/Frame 572.svg";
import Videos from "./icons/media.svg";
import { TextView } from "..";

import { Col, Form, Row, Card, Button } from "react-bootstrap";

import RenderMedia from "./renderMedia";
import RenderLegend from "./renderLegend";

import { useFormikContext } from "formik";
import { colors } from "../../utils";
import { useSelector } from "react-redux";
import WheelPantry from "../WheelPantry";
import { Stack } from "@mui/material";
import insertChartSegment from "../../utils/wheelUtils";

function WheelRightSideBar({
  Links,
  isViewMediaOpen,
  setIsViewMediaOpen,
  isViewLinksOpen,
  setIsViewLinksOpen,
  editorRef,
}) {
  const [isCategoryListOpen, setIsCategoryListOpen] = useState(false);
  const [isArchiveListExpanded, setIsArchiveListExpanded] = useState(false);
  const [isHotbarVisible, setIsHotbarVisible] = useState(false);

  const { setFieldValue } = useFormikContext();

  const values = Links;

  const categoryData = useSelector((state) => state.categoryColors);

  const handleToggleArchiveList = () => {
    setIsArchiveListExpanded(!isArchiveListExpanded);
  };
  const toggleCategoryListOpen = () => {
    setIsCategoryListOpen(!isCategoryListOpen);
    setIsViewLinksOpen(false);
    setIsViewMediaOpen(false);
  };

  const toggleViewMediaOpen = () => {
    setIsViewMediaOpen(!isViewMediaOpen);
    setIsCategoryListOpen(false);
    setIsViewLinksOpen(false);
  };

  const toggleHotbarOpen = () => {
    setIsHotbarVisible((prevState) => !prevState);
  };
  const toggleViewLinksOpen = () => {
    setIsViewLinksOpen(!isViewLinksOpen);
    setIsCategoryListOpen(false);
    setIsViewMediaOpen(false);
  };

  const [normalList, setNormalList] = useState(values.normal_links ?? []);

  useEffect(() => {
    setNormalList((prev) => prev.filter((url) => values.urls.includes(url)));
    setStarredList((prev) => prev.filter((url) => values.urls.includes(url)));
    setArchiveList((prev) => prev.filter((url) => values.urls.includes(url)));

    values.urls.map((url) => {
      if (
        !starredList.includes(url) &&
        !archiveList.includes(url) &&
        !normalList.includes(url)
      ) {
        setNormalList([...normalList, url]);
      }
    });
  }, [values.urls]);

  const [starredList, setStarredList] = useState(values.starred_links ?? []);
  const [archiveList, setArchiveList] = useState(values.archived_links ?? []);

  useEffect(() => {
    setFieldValue("normal_links", normalList);
    setFieldValue("archived_links", archiveList);
    setFieldValue("starred_links", starredList);
  }, [starredList, archiveList, normalList]);

  // Function to handle starring a link
  const handleStar = (link) => {
    if (!normalList.includes(link)) return;

    // Remove from normalList
    setNormalList((prev) => prev.filter((item) => item !== link));

    // Add to starredList if not already there
    if (!starredList.includes(link)) {
      setStarredList((prev) => [...prev, link]);
    }
  };

  // Function to handle unstarring a link
  const handleUnStar = (link) => {
    if (!starredList.includes(link)) return;

    // Remove from starredList
    setStarredList((prev) => prev.filter((item) => item !== link));

    // Add back to normalList
    setNormalList((prev) => [...prev, link]);
  };

  // Function to handle archiving a link
  const handleArchive = (link) => {
    if (!normalList.includes(link) && !starredList.includes(link)) return;

    // Remove from normalList or starredList
    setNormalList((prev) => prev.filter((item) => item !== link));
    setStarredList((prev) => prev.filter((item) => item !== link));

    // Add to archiveList
    setArchiveList((prev) => [...prev, link]);
  };

  // Function to handle undoing an archive action
  const handleUndo = (link) => {
    if (!archiveList.includes(link)) return;

    // Remove from archiveList
    setArchiveList((prev) => prev.filter((item) => item !== link));

    // Add back to normalList
    setNormalList((prev) => [...prev, link]);
  };

  const [showWheelPantry, setShowWheelPantry] = useState(false);

  const renderLinkItem = (data, isArchived = false) => {
    return (
      <div
        style={{
          display: "flex",
          marginBottom: "4px",
          justifyContent: "space-between",
          alignItems: "center",
          border: "1px solid #E1E1E1",
          borderRadius: "20px",
          padding: "4px 8px 4px 8px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <div>
            {starredList.some((e) => e === data) ? (
              <StarRateRoundedIcon
                onClick={() => handleUnStar(data)}
                style={{ color: "#F5CC3B", fontSize: "15px" }}
                size="small"
              />
            ) : (
              <StarOutlineRoundedIcon
                onClick={() => handleStar(data)}
                style={{ fontSize: "15px" }}
                size="small"
              />
            )}
          </div>

          <Typography
            variant="subtitle2"
            component="subtitle2"
            onClick={() => window.open(data, "_blank")}
            style={{
              fontFamily: "DM Sans",
              fontWeight: "200",
              textDecoration: "underline",
              color: "#0058B8",
              cursor: "pointer",
              fontSize: "10px",
              marginTop: "4px",
              marginLeft: "3px",
            }}
          >
            {data.slice(0, 20)}
          </Typography>
        </div>
        {isArchived ? (
          <ReplayIcon
            size="small"
            onClick={() => handleUndo(data)}
            style={{ fontSize: "15px" }}
          />
        ) : (
          <img
            onClick={() => {
              handleArchive(data);
            }}
            src={ASSETS.removeIcon}
            alt="icon"
            style={{ height: "14px", width: "14px", cursor: "pointer" }}
          />
        )}
      </div>
    );
  };

  return (
    <div>
      <div style={{ textAlign: "end" }}>
        {isViewLinksOpen ? null : (
          <img
            onClick={toggleViewLinksOpen}
            src={LinkIcon}
            alt="icon"
            style={{
              height: "55px",
              width: "60px",
              position: "relative",
              cursor: "pointer",
            }}
          />
        )}

        {isViewLinksOpen ? (
          <>
            <div style={{ height: !isViewLinksOpen && "0px" }}>
              <div className={`categoryList ${isViewLinksOpen ? "open" : ""}`}>
                {isViewLinksOpen && (
                  <div
                    onClick={toggleViewLinksOpen}
                    style={{
                      height: 28,
                      width: 20,
                      borderRadius: 5,
                      backgroundColor: colors.primary,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "absolute",
                      marginTop: 20,
                      marginLeft: -10,
                      cursor: "pointer",
                      zIndex: 100,
                    }}
                  >
                    <ChevronRightIcon
                      fontSize="medium"
                      style={{ color: "white" }}
                    />
                  </div>
                )}
              </div>
            </div>
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "20px",
                padding: "10px",
                width: "17vw",
              }}
            >
              <div style={{ marginTop: 10 }} className="hotbar-header">
                <div className="hotbar-header-left">
                  <img
                    className="hotbar-icon"
                    src={ASSETS.linksIcon}
                    alt="icon"
                  />

                  <TextView style={{ marginLeft: 5 }} variant="title">
                    View Links
                  </TextView>
                </div>
              </div>

              <div
                style={{
                  overflowY: "auto",
                  minHeight: "30vh",
                  maxHeight: "40vh",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    marginTop: "5px",
                  }}
                >
                  <StarRateRoundedIcon
                    style={{
                      color: "#F5CC3B",
                      fontSize: "20px",
                      marginLeft: "5px",
                    }}
                    size="medium"
                  />
                  <Typography
                    variant="subtitle1"
                    component="subtitle1"
                    style={{
                      fontFamily: "DM Sans",
                      fontWeight: "500",
                      marginLeft: "5px",
                      fontSize: "12px",
                    }}
                  >
                    Starred Links
                  </Typography>
                </div>

                <div
                  style={{
                    backgroundColor: "#f6f7f9",
                    borderRadius: "10px",
                    padding: "10px",
                    borderLeft: "10px solid #EFAC00",
                    marginTop: "10px",
                  }}
                >
                  {starredList?.length > 0 ? (
                    starredList.map((data) => renderLinkItem(data))
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        fontFamily: "DM Sans",
                        fontSize: "10px",
                      }}
                    >
                      Not Starred Items
                    </div>
                  )}
                </div>
                <div style={{ textAlign: "initial", marginTop: "20px" }}>
                  <img
                    src={ASSETS.linksIcon}
                    alt="icon"
                    style={{ height: "22px", width: "22px" }}
                  />
                  <Typography
                    variant="subtitle1"
                    component="subtitle1"
                    style={{
                      fontFamily: "DM Sans",
                      fontWeight: "500",
                      fontSize: "12px",
                      marginLeft: "7px",
                      marginRight: "30px",
                      marginTop: "20px",
                    }}
                  >
                    Links Overview
                  </Typography>
                </div>
                <div
                  style={{
                    backgroundColor: "#f6f7f9",
                    borderRadius: "10px",
                    padding: "10px",
                    borderLeft: "10px solid #123051",
                    marginTop: "10px",
                  }}
                >
                  {normalList?.length > 0 ? (
                    normalList.map((data) => renderLinkItem(data))
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        fontFamily: "DM Sans",
                        fontSize: "10px",
                      }}
                    >
                      Not Available
                    </div>
                  )}
                </div>
              </div>
            </div>

            {archiveList.length ? (
              <div style={{ opacity: archiveList.length === 0 ? 0.5 : 1 }}>
                <Accordion
                  disabled={archiveList?.length === 0}
                  expanded={isArchiveListExpanded && archiveList?.length > 0}
                  onChange={handleToggleArchiveList}
                  style={{
                    backgroundColor: "white",
                    borderRadius: "20px",
                    width: "17vw",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={ASSETS.linksIcon}
                        alt="icon"
                        style={{ height: "22px", width: "22px" }}
                      />
                      <Typography
                        variant="h6"
                        component="h6"
                        style={{
                          marginLeft: "5px",
                          fontFamily: "DM Sans",
                          fontWeight: "500",
                          fontSize: "12px",
                        }}
                      >
                        Archived Links
                      </Typography>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div
                      style={{
                        backgroundColor: "#f6f7f9",
                        borderRadius: "10px",
                        padding: "10px",
                        borderLeft: "10px solid #e8091d",
                        fontFamily: "DM Sans",
                        fontSize: "10px",
                        marginTop: "-10px",
                      }}
                    >
                      {archiveList?.length > 0
                        ? archiveList.map((data) => renderLinkItem(data, true))
                        : "Not Available"}
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            ) : null}
          </>
        ) : null}
      </div>

      {/* View Media  */}

      <div style={{ textAlign: "end" }}>
        {isViewMediaOpen ? null : (
          <img
            onClick={toggleViewMediaOpen}
            src={Videos}
            alt="icon"
            style={{
              height: "55px",
              width: "60px",
              position: "relative",
              marginTop: "14px",
              cursor: "pointer",
            }}
          />
        )}
      </div>

      {isViewMediaOpen ? (
        <RenderMedia
          images={values.images}
          videos={values.videos}
          audios={values.audios}
          documents={values.documents}
          isViewMediaOpen={isViewMediaOpen}
          toggleViewMediaOpen={toggleViewMediaOpen}
          toggleHotbarOpen={toggleHotbarOpen}
        />
      ) : null}

      {isHotbarVisible ? (
        <Hotbar
          images={values.images}
          videos={values.videos}
          audios={values.audios}
          documents={values.documents}
        />
      ) : null}

      {!showWheelPantry && (
        <Stack
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"flex-end"}
        >
          <div
            onClick={() => setShowWheelPantry(true)}
            style={{
              height: "55px",
              width: "56px",
              position: "relative",
              cursor: "pointer",
              marginTop: "15px",
              backgroundColor: colors.primary,
              borderRadius: "10px",
              marginLeft: "3px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              onClick={() => setShowWheelPantry(true)}
              alt="pantry"
              src={ASSETS.pantry}
              style={{
                height: "35px",
                width: "35px",
                position: "relative",
                // marginTop: "1px",
                cursor: "pointer",
                borderRadius: "15px",
                overflow: "hidden",
              }}
            />
          </div>
        </Stack>
      )}

      {showWheelPantry && (
        <WheelPantry
          onClose={() => setShowWheelPantry(false)}
          editorRef={editorRef}
          // onLinkWheelPress={(wheelToBeLinked, NodeForScreeshot) => {
          //   console.log({ wheelToBeLinked, NodeForScreeshot });
          //   if (NodeForScreeshot?.outerHTML) {
          //     editorRef?.current?.insertContent(
          //       ReactDOMServer.renderToStaticMarkup(NodeForScreeshot?.outerHTML)
          //     );
          //   }
          // }}
          onAddSegment={(data) => {
            if (!values.chart.some((item) => item.id === data.id)) {
              const updatedChartData = insertChartSegment(values.chart, data);
              setFieldValue("chart", updatedChartData);
            }
          }}
        />

        // <Toolbar onClose={() => setShowWheelPantry(false)} />
      )}

      {isCategoryListOpen ? (
        <RenderLegend
          isCategoryListOpen={isCategoryListOpen}
          toggleCategoryListOpen={toggleCategoryListOpen}
          categoryData={categoryData?.categories}
        />
      ) : null}
    </div>
  );
}

export default WheelRightSideBar;
